import React from 'react'
import { Dropdown, Menu, Checkbox, Button, Icon } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { observer } from 'mobx-react-lite'
import { ProductFilter } from './ProductFilter'
import { ProductModels } from '@getgreenline/products'

interface StrainTypeSelectProps {
  productFilter: ProductFilter
}

const strainTypes = Object.values(ProductModels.EProductStrainType)

export const StrainTypeSelect = observer(({ productFilter }: StrainTypeSelectProps) => {
  const onChangeStrainType = (
    e: CheckboxChangeEvent,
    strainType: ProductModels.EProductStrainType,
  ) => {
    const { selectedStrainTypes } = productFilter.productFilter
    if (e.target.checked) {
      if (selectedStrainTypes) {
        productFilter.setSelectedStrainTypes([...selectedStrainTypes, strainType])
      } else {
        productFilter.setSelectedStrainTypes([strainType])
      }
    } else {
      if (selectedStrainTypes) {
        productFilter.setSelectedStrainTypes(
          selectedStrainTypes.filter(
            (strainTypeToRemove: ProductModels.EProductStrainType) =>
              strainTypeToRemove !== strainType,
          ),
        )
      }
    }
  }

  const getButtonLabel = () => {
    return productFilter.productFilter.selectedStrainTypes?.length === strainTypes.length
      ? `Strain type (all)`
      : productFilter.productFilter.selectedStrainTypes?.length !== 0 &&
        productFilter.productFilter.selectedStrainTypes !== undefined
      ? `Strain type (${productFilter.productFilter.selectedStrainTypes?.length})`
      : `Strain type (none)`
  }

  return (
    <Dropdown
      className='gr-filter-item gr-filter-gutter'
      trigger={['click']}
      overlay={
        <Menu>
          <Menu.Item
            key='all'
            disabled
            style={{
              padding: 0,
              borderBottom: '1px solid #e8e8e8',
              marginLeft: '12px',
              marginRight: '12px',
            }}
          >
            <Checkbox
              checked={
                productFilter.productFilter.selectedStrainTypes?.length === strainTypes.length
              }
              className='w-100'
              style={{ padding: '5px 0px' }}
              onChange={(e) => {
                e.target.checked
                  ? productFilter.setSelectedStrainTypes(strainTypes)
                  : productFilter.setSelectedStrainTypes([])
              }}
            >
              <b>Select All</b>
            </Checkbox>
          </Menu.Item>
          {strainTypes.map((strainType) => {
            return (
              <Menu.Item key={strainType} disabled style={{ padding: 0 }}>
                <Checkbox
                  checked={productFilter.productFilter.selectedStrainTypes?.includes(strainType)}
                  className='w-100'
                  style={{ padding: '5px 12px' }}
                  onChange={(e) => onChangeStrainType(e, strainType)}
                >
                  {strainType}
                </Checkbox>
              </Menu.Item>
            )
          })}
        </Menu>
      }
    >
      <Button
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '34px',
        }}
      >
        {getButtonLabel()} <Icon type='down' />
      </Button>
    </Dropdown>
  )
})
